/**
 * product
 */

import $ from 'jquery';
import Vue from 'vue/dist/vue';
import Page from 'js/lib/page';

import store, { eventBus } from 'js/lib/Store';
import counter from '~/counter/counter';

export default class Product extends Page {
  init() {
    const id = this.$.root.data('id');
    const amount = this.$.root.data('amount');

    this.vm = new Vue({
      el: this.$.root.get(0),
      data: {
        id,
        amount,
        inCart: false,
        isReady: false,
        isLoading: false
      },
      store,
      components: {
        counter
      },
      methods: {
        sync() {
          store.dispatch('getProduct', this.id).then(([product]) => {
            this.isReady = true;
            if (product) {
              this.inCart = true;
            }
          });
        },
        handler() {
          this.addToCart({
            id: this.id,
            amount: this.amount
          });
        },
        addToCart(data) {
          this.isLoading = true;

          if (id) {
            eventBus.$emit('cart.notify', { amount: 1 });
            store
              .dispatch('addProduct', data)
              .done(() => {
                this.inCart = true;
              })
              .fail(err => {
                console.error(err);
              });
          }
        },
        updateAmount({ amount }) {
          this.amount = amount;
        }
      },
      mounted() {
        setTimeout(() => this.sync(), 1000);

        eventBus.$on('product.remove', ({ id }) => {
          if (id === this.id) {
            this.inCart = false;
          }
        });

        eventBus.$on('product.add', ({ id }) => {
          if (id === this.id) {
            this.inCart = true;
          }
        });
      }
    });
  }
}

Page.make(Product, '.js-product');
